import React from 'react'

interface InputProps {
    name?: string;
    value: string;
    type?: string;
    required?: boolean;
    placeholder?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    maxLength?: number
    upperCase?: string
    disabled?: boolean;
    isUpdateName?: boolean;
    isChange?: boolean;
    padding?: string
    textSize?: string; 
}

export default function Input({ textSize = 'text-xs', name, value, type = "text", padding = 'py-1.5 px-2', placeholder, onChange, required, maxLength, upperCase, disabled = false, isUpdateName, isChange } : InputProps) {
    
    return (
        <>
            <input 
                name={name}
                type={type}
                value={value}
                onChange={onChange}
                className={`block w-full ${textSize} rounded border border-gray-300 ${padding} shadow-sm outline-none placeholder:text-gray-400 focus:border-black cursor-pointer ${disabled ? 'bg-gray-100' : ''} ${upperCase} ${disabled ? 'cursor-not-allowed' : ''}`}
                placeholder={placeholder}
                required={required}
                minLength={type === "password" ? 6 : undefined}
                maxLength={maxLength}
                disabled={disabled}
                autoComplete="current-password"
            />
        </>
    )
}
